import { SiteName } from '@/scopes/common/domain/types'

// 1 January 2028 at midnight in the Netherlands (CET).
const WEBSITE_AWARD_EXPIRES_AT = new Date('2028-01-01T00:00:00+01:00')

interface LanguageSettings {
  urlMatcher: string
  translationKey: string
  url: string
}

export function getLanguageSettings(siteName: SiteName): LanguageSettings[] | null {
  if (siteName === 'sunwebbefr') {
    return [
      {
        urlMatcher: '/fr',
        translationKey: 'language_french',
        url: '/fr',
      },
      {
        urlMatcher: '/nl',
        translationKey: 'language_netherlands',
        url: '/nl',
      },
    ]
  }

  if (siteName === 'sunwebbenl') {
    return [
      {
        urlMatcher: '/nl',
        translationKey: 'language_netherlands',
        url: '/nl',
      },
      {
        urlMatcher: '/fr',
        translationKey: 'language_french',
        url: '/fr',
      },
    ]
  }

  return null
}

export function shouldShowFooterLegalDisclaimer(siteName: SiteName): boolean {
  return siteName === 'sunwebuk'
}

export function shouldShowFooterWebsiteAward(siteName: SiteName, currentDate: Date): boolean {
  return (siteName === 'sunwebnl' || siteName === 'elizanl')
    && currentDate.getTime() < WEBSITE_AWARD_EXPIRES_AT.getTime()
}
